const TransferCustomer = () =>
  import('@/views/main/wechatMgmt/transferCustomer/TransferCustomer.vue')
export default {
  path: '/main/wechatMgmt/transferCustomer',
  name: 'TransferCustomer',
  component: TransferCustomer
}
